(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .component('sc3GameTrackerDriving', {
            templateUrl: 'app/game-tracker/driving/game-tracker-driving.component.html',
            controller: GameTrackerDrivingComponent,
            bindings: {
                data: '<'
            }
        });

    GameTrackerDrivingComponent.$inject = ['gameTrackerChartFactory'];
    function GameTrackerDrivingComponent(gameTrackerChartFactory) {
        var ctrl = this;
        ctrl.chart = null;
        ctrl.$onInit = init;

        ///////////////////////////////////////////////////////////

        function init() {
            ctrl.chart = gameTrackerChartFactory(ctrl.data.summary);
        }
    }
})();